import randomHashGenerator from "../../utils/helpers/randomHashGenerator";

const DEVICE_ID_KEY = '@robotica/appv2/deviceId';

export const getOrGenerateDeviceId = () => {
    const deviceId = localStorage.getItem(DEVICE_ID_KEY);
    if (deviceId) {
        return deviceId;
    } else {
        const deviceId = randomHashGenerator();
        localStorage.setItem(DEVICE_ID_KEY, deviceId);
        return deviceId;
    }
};

export const getOSName = () => {
    const userAgent = navigator.userAgent;
    if (userAgent.includes("Windows")) return "Windows";
    if (userAgent.includes("Mac")) return "MacOS";
    if (userAgent.includes("Linux")) return "Linux";
    if (userAgent.includes("Android")) return "Android";
    if (userAgent.includes("like Mac")) return "iOS";
    return "Unknown OS";
};

export const getBrowserVersion = () => {
    const userAgent = navigator.userAgent;
    const match =
        userAgent.match(/(chrome|firefox|safari|opera|edge|msie|trident)\/?\s*(\d+)/i) || [];
    return match[1] ? `${match[1]} ${match[2]}` : "Unknown Browser";
};

export const isTablet = () => {
    return /iPad|Tablet|Android(?!.*Mobile)/i.test(navigator.userAgent);
};
